import { render } from "./user-role.vue?vue&type=template&id=3d55405a&scoped=true"
import script from "./user-role.vue?vue&type=script&lang=js"
export * from "./user-role.vue?vue&type=script&lang=js"

import "./user-role.vue?vue&type=style&index=0&id=3d55405a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d55405a"]])

export default __exports__